import { GetBorrowerProjectInfosResponse, GetRgiRiskResponse, GetUnemploymentRiskResponse, GetUpiRiskResponse } from "api/risk"
import { createContextSelectorHooks } from "core/utils/contextUtils"
import { SubscriptionProcessContext, SubscriptionProcessContextProps } from "../SubscriptionProcessContext"
import { SubscriptionProcessState } from "../types"

export const {
  useSelector: useSubscriptionProcessSelector,
  useSelectorWithEquality: useSubscriptionProcessSelectorWithEquality
} = createContextSelectorHooks<SubscriptionProcessContextProps, SubscriptionProcessState>(
  SubscriptionProcessContext,
  'SubscriptionProcess'
)

// Main state selector - returns all commonly used state
export const useSubscriptionProcessState = () => {
  const riskId = useSubscriptionProcessSelector(state => state.riskId)
  const folderIdentifier = useSubscriptionProcessSelector(state => state.folderIdentifier)
  const branchCode = useSubscriptionProcessSelector(state => state.branchCode)
  const subscriptionState = useSubscriptionProcessSelector(state => state.subscriptionState)
  const riskData = useSubscriptionProcessSelector(state => state.riskData)
  const contractualizationData = useSubscriptionProcessSelector(state => state.contractualizationData)
  const isLoading = useSubscriptionProcessSelector(state => state.isLoading)
  const unreadHistoryCount = useSubscriptionProcessSelector(state => state.unreadHistoryCount)

  return {
    riskId,
    folderIdentifier,
    branchCode,
    subscriptionState,
    riskData,
    contractualizationData,
    unreadHistoryCount,
    // Convenience accessors from subscriptionState
    currentStepIdentifier: subscriptionState.currentStepIdentifier,
    highestAccessibleStep: subscriptionState.highestAccessibleStep,
    isProcessCompleted: subscriptionState.isProcessCompleted,
    steps: subscriptionState.steps,
    isLoading
  }
}

// Typed risk data selectors for each branch
export const useUnemploymentRiskData = () => {
  const riskData = useSubscriptionProcessSelector(state => state.riskData)
  return riskData as GetUnemploymentRiskResponse | null
}

export const useUpiRiskData = () => {
  const riskData = useSubscriptionProcessSelector(state => state.riskData)
  return riskData as GetUpiRiskResponse | null
}

export const useRgiRiskData = () => {
  const riskData = useSubscriptionProcessSelector(state => state.riskData)
  return riskData as GetRgiRiskResponse | null
}

export const useBorrowerRiskData = () => {
  const riskData = useSubscriptionProcessSelector(state => state.riskData)
  return riskData as GetBorrowerProjectInfosResponse | null
}

// Risk data selector
export const useRiskData = () => {
  return useSubscriptionProcessSelector(state => state.riskData)
}

// Contractualization data selector
export const useContractualizationData = () => {
  return useSubscriptionProcessSelector(state => state.contractualizationData)
}

export const useIsLoading = () => {
  return useSubscriptionProcessSelector(state => state.isLoading)
}

export const useError = () => {
  return useSubscriptionProcessSelector(state => state.error)
}
